module.exports = __webpack_public_path__ + "img/924e4ef.jpg";